import { Alerta, Botao, TipoAlerta, TipoBotao } from "@intechprev/componentes-web";
import React, { useEffect, useState } from "react";
import { AvaliacaoEntidade } from "../entidades";
import { AvaliacaoService } from "../services/AvaliacaoService";

interface IProps {
  onSend: () => Promise<void>;
  numFuncionalidade: number;
  cdPlano: string;
}

const Avaliacao: React.FC<IProps> = ({ numFuncionalidade, cdPlano, onSend }) => {
  const TOTAL_NOTA = Array.from({ length: 5 }, (_, i) => i + 1);

  const [Loading, setLoading] = useState(false);
  const [Erro, setErro] = useState("");

  const [Texto, setTexto] = useState("");
  const [Nota, setNota] = useState(0);
  const [Comentario, setComentario] = useState("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {

        const texto = await AvaliacaoService.BuscarTexto(numFuncionalidade);
        setTexto(texto.TXT_TEXTO);

      }
      catch (e) {
        const err: any = e;
        const Error = err.response ? err.response.data : err;
        setErro(Error);
      }
      finally {
        setLoading(false);
      }
    })();
  }, [numFuncionalidade]);

  function handleChangeComentario(e: any) {
    setComentario(e.target.value);
  }

  async function handleEnviar() {
    try {
      if (Nota === 0) {
        alert("Por favor, escolha uma nota para a funcionalidade");
        return;
      }

      const avaliacao: AvaliacaoEntidade = {
        NUM_FUNCIONALIDADE: numFuncionalidade,
        NUM_NOTA: Nota,
        TXT_COMENTARIO: Comentario,
        CD_PLANO: cdPlano,
      };

      await AvaliacaoService.Enviar(avaliacao);

      alert("Sua avaliação foi enviada com sucesso!");

      await onSend();
    }
    catch (e) {
      const err: any = e;
      const Error = err.response ? err.response.data : err;
      setErro(Error);
    }
  }

  return (
    <div className="modal">
      <div className="modal-dialog modal-dialog-scrollable">
        <div className="modal-content modal-avaliacao">
          {Loading && <div className="text-center">Carregando...</div>}
          {!Loading && Erro && (
            <>
              <Alerta tipo={TipoAlerta.danger}>{Erro}</Alerta>
            </>
          )}

          {!Loading && !Erro && (
            <>
              <div className="modal-avaliacao-titulo">{Texto}</div>

              <div className="modal-avaliacao-notas">
                <span className="mr-2">Ruim</span>
                {TOTAL_NOTA.map((nota: number) => (
                  <Botao
                    titulo={nota.toString()}
                    tipo={Nota === nota ? TipoBotao.success : TipoBotao.light}
                    desativado={Nota === nota}
                    className="mr-2"
                    onClick={() => setNota(nota)}
                  />
                ))}
                <span>Ótimo</span>
              </div>

              <div className="modal-avaliacao-comentario mb-2">Faça aqui um comentário, sugestão, elogio ou reclamação:</div>

              <div className="modal-avaliacao-comentario">
                <textarea value={Comentario} rows={5} onChange={handleChangeComentario} maxLength={100}></textarea>
              </div>

              <div className="modal-avaliacao-confirmar">
                <Botao titulo="Enviar" tipo={TipoBotao.primary} onClick={handleEnviar} icone="fas fa-paper-plane" />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Avaliacao;
